import { axiosGetAuthorize, axiosPost, axiosPostAuthorize } from '../AxiosRequests';
import {
    GetALLMembershipEnquiryList,
    GetMembershipEnquiryById,
    RenewNewCorporateMember,
} from '../ApiEndPoints';

export default class WebMembershipCorporateServices {

    async getALLMembershipEnquiryList(request) {
        return axiosPostAuthorize(GetALLMembershipEnquiryList, request);
    }

    async getMembershipEnquiryById(request) {
        return axiosGetAuthorize(GetMembershipEnquiryById, request);
    }
    async renewNewCorporateMember(request){
        return axiosPostAuthorize(RenewNewCorporateMember,request);
    }
}